import { Grid } from "@mui/material";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Stepper from "@mui/material/Stepper";
import { fetchLoggedInUserInfoAsync, setLoadPages } from "components/app/App.slice";
import Button from "components/common/Button";
import Typography from "components/common/Typography";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import {
  getInitialWizardTaken,
  getLoggedInUserHltId,
  setInitialWizardTaken,
  valueIsEmpty
} from "utils/CommonFunctions";
import { responseTypes } from "utils/Types";
import { ON_BOARDING } from "utils/URLConstants";
import { fetchSuggestedPlansIdAsync } from "../library/SuggestedPlans/SuggestedPlans.slice";
import {
  reset,
  setInitialWizard,
  setShowOnboardingWizard,
  setShowOnboardingWizardFromLibrary,
  updateOnboardingQueries
} from "./Onboarding.slice";
import QnA from "./QnA";
interface Props {
  onboardingDetails?: any;
  onStepChange: (data: any) => void;
}

const StepContent = (props: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { onboardingDetails } = props;
  const steps = onboardingDetails.questionnaire;
  const isInitialOnboardingCompleted: boolean = getInitialWizardTaken();

  const innCode = useAppSelector((state) => state.app.innCode);
  const showOnboardingWizardFromLibrary: any = useAppSelector(
    (state) => state.Onboarding.showOnboardingWizardFromLibrary
  );

  const [activeStep, setActiveStep] = useState(0);
  const [allAnswers, setAllAnswers] = useState<any>({});
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(false);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  useEffect(() => {
    props.onStepChange(activeStep + 1);
  }, [activeStep]);

  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };

  const getQuestionData = () => {
    let onboardingDetailsData = JSON.parse(JSON.stringify(onboardingDetails));
    const modifiedResponse = onboardingDetailsData.questionnaire.map((question: any) => {
      switch (question.questionType) {
        case "SINGLE_CHOICE":
          question.options.forEach((option: any) => {
            if (option.answerOption === allAnswers[question.quesId]) {
              option.selectedValue = allAnswers[question.quesId];
              option.isSelected = "Y";
            } else {
              option.selectedValue = "";
              option.isSelected = "N";
            }
          });
          return question;

        case "MCQ":
          question.options.forEach((option: any) => {
            const answerOption = allAnswers[question.quesId];
            if (answerOption?.indexOf(option.answerOption) >= 0 && !option.unavailable) {
              option.selectedValue = answerOption[answerOption.indexOf(option.answerOption)];
              option.isSelected = "Y";
            } else {
              option.selectedValue = "";
              option.isSelected = "N";
            }
          });
          return question;

        case "SCALE":
          question.options.forEach((option: any) => {
            option.selectedValue = allAnswers[question.quesId];
            option.isSelected = "Y";
          });
          return question;
        case "FILTER_MCQ":
          question.options.forEach((option: any) => {
            const answerOption = allAnswers[question.quesId];
            if (answerOption?.indexOf(option.answerOption) >= 0) {
              option.selectedValue = answerOption[answerOption.indexOf(option.answerOption)];
              option.isSelected = "Y";
            } else {
              option.selectedValue = "";
              option.isSelected = "N";
            }
          });
          return question;

        default:
          return question;
      }
    });
    onboardingDetailsData.questionnaire = modifiedResponse;
    return onboardingDetailsData;
  };

  const handleSubmit = async () => {
    const onBoardingData: any = {
      innCode: innCode,
      wizardType: ON_BOARDING,
      payload: {}
    };

    onBoardingData.payload = getQuestionData();
    onBoardingData.payload.id = 0;
    onBoardingData.payload.createdDate = null;
    onBoardingData.payload.updatedDate = null;
    setIsBtnDisabled(true);
    const response = await dispatch(updateOnboardingQueries(onBoardingData));
    if (response.payload.status < responseTypes.success_threshold) {
      await dispatch(fetchLoggedInUserInfoAsync({ size: 1, hltIds: getLoggedInUserHltId() }));
      dispatch(setShowOnboardingWizard(false));
      dispatch(reset());
      dispatch(setLoadPages(true));

      if (showOnboardingWizardFromLibrary) {
        navigate("/library");
        dispatch(fetchSuggestedPlansIdAsync({ innCode }));
      }
      dispatch(setShowOnboardingWizardFromLibrary(false));
      if (!isInitialOnboardingCompleted) {
        setInitialWizardTaken();
        dispatch(setInitialWizard(true));
      }
    }
  };

  function renderStepContent(step: number) {
    return (
      <QnA
        allAnswers={allAnswers}
        setAllAnswers={setAllAnswers}
        currQues={steps?.[step]}
        retakeWizard={onboardingDetails?.questionnaire?.length === 1}
      />
    );
  }

  function areAllSelectedItemsUnavailable(): boolean {
    const options = steps[activeStep]?.options || [];
    const matchedOptions = options.filter((opt: any) =>
      allAnswers?.[steps[activeStep].quesId]?.includes(opt.answerOption)
    );
    return matchedOptions.length > 0 && matchedOptions.every((opt: any) => opt.unavailable === true);
  }

  return (
    <>
      {onboardingDetails?.questionnaire?.length > 1 && (
        <Stepper sx={{ width: "100%", marginTop: "16px" }} activeStep={activeStep} alternativeLabel>
          {steps.map((step: any, index: number) => {
            const stepProps: { completed?: boolean } = {};
            return (
              <Step
                sx={{
                  "& .MuiButtonBase-root": {
                    margin: "-27px -16px",
                    display: "inherit"
                  },
                  "& .MuiStepLabel-root .Mui-disabled .MuiSvgIcon-root": {
                    fill: tokens.Background.General.Primary,
                    boxShadow: "0px 0px 4px rgba(19, 41, 138, 0.1), 0px 10px 25px rgba(19, 41, 138, 0.1)",
                    borderRadius: "50%"
                  },
                  "& .MuiStepLabel-root .Mui-disabled .MuiStepIcon-text": {
                    fill: tokens.Text.General.Tertiary
                  },
                  "& .MuiStepLabel-root .Mui-active": {
                    color: tokens.Primary.Primary400
                  },
                  "& .MuiStepLabel-root .Mui-completed": {
                    color: tokens.Border.General.Secondary
                  },
                  "& .MuiStepConnector-line": {
                    border: `2px dashed ${tokens.Border.General.Tertiary}`
                  },
                  "& .MuiStepLabel-iconContainer .MuiStepIcon-text": {
                    fontSize: "20px"
                  },
                  "& .MuiSvgIcon-root": {
                    width: "34px",
                    height: "34px"
                  }
                }}
                key={step.quesId}
                {...stepProps}
              >
                <StepButton onClick={handleStep(index)}>
                  <Typography variant={"label"} color={tokens.Text.General.Secondary}>
                    Step {index + 1}
                  </Typography>
                </StepButton>
              </Step>
            );
          })}
        </Stepper>
      )}
      {renderStepContent(activeStep)}

      <Grid container sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", paddingX: "16px" }}>
        {activeStep > 0 && (
          <Button
            variant="secondary"
            sx={{ display: "inherit" }}
            disabled={activeStep === 0}
            onClick={handleBack}
            label="Back"
          />
        )}
        <Button
          sx={{ marginLeft: "8px" }}
          variant="primary"
          disabled={
            valueIsEmpty(allAnswers?.[steps?.[activeStep]?.quesId]) || areAllSelectedItemsUnavailable() || isBtnDisabled
          }
          onClick={activeStep === steps?.length - 1 ? handleSubmit : handleNext}
          label={activeStep === steps?.length - 1 ? "Submit" : "Next"}
        />
      </Grid>
    </>
  );
};

export default StepContent;
